import * as PourOver from 'pourover';

import { FilterBase, andIn, orIn } from './FilterBase';

/**
 * Sorry. Weird mismatches here between what the user is shown (for example, "Accepted") and what we called
 * it in storage and code ("approve" or "approved"). They try to pick something that resonates with users
 * and sometimes it changes...
 */
export class CrossTypeFilter extends FilterBase {
  needsSubset = true;

  sellerrecommendsprimary: any;
  sellerrecommendsalternate: any;
  sellerrecommendsselfcross: any;
  vizientcrossattribute: any;
  vizientcrossderived: any;
  buyerrecommendsprimary: any;
  incumbentSelfCross: any;

  makeIndex(): any {
    return new PourOver.makeInclusionFilter('crossType', [
      'sellerrecommendsprimary',
      'sellerrecommendsalternate',
      'sellerrecommendsselfcross',
      'vizientcrossattribute',
      'vizientcrossderived',
      'buyerrecommendsprimary'
    ]);
  }

  getMatchSet(collection, filterSettings) {

    this.sellerrecommendsprimary = collection.filters.crossType.getFn('sellerrecommendsprimary');
    this.sellerrecommendsalternate = collection.filters.crossType.getFn('sellerrecommendsalternate');
    this.sellerrecommendsselfcross = collection.filters.crossType.getFn('sellerrecommendsselfcross');
    this.vizientcrossattribute = collection.filters.crossType.getFn('vizientcrossattribute');
    this.vizientcrossderived = collection.filters.crossType.getFn('vizientcrossderived');
    this.buyerrecommendsprimary = collection.filters.crossType.getFn('buyerrecommendsprimary');
    this.incumbentSelfCross = collection.filters.incumbentSelfCross.getFn(true);

    let union = null;

    if (filterSettings.showSellerRecommendsPrimary) {
      union = orIn(union, this.sellerrecommendsprimary);
    }

    if (filterSettings.showSellerRecommendsAlternate) {
      union = orIn(union, this.sellerrecommendsalternate);
    }

    if (filterSettings.showSellerRecommendsSelfCross) {
      union = orIn(union, this.sellerrecommendsselfcross);
      union = orIn(union, this.incumbentSelfCross);
    }

    if (filterSettings.showVizientCrossAttribute) {
      union = orIn(union, this.vizientcrossattribute);
    }

    if (filterSettings.showVizientCrossDerived) {
      union = orIn(union, this.vizientcrossderived);
    }

    if (filterSettings.showBuyerRecommends) {
      union = orIn(union, this.buyerrecommendsprimary);
    }

    return union;
  }

  getCounts(filterCombinations): any {
    let temp = andIn(
      filterCombinations.subsets[this.constructor.name],
      filterCombinations.incumbentsFilter
    );

    return {
      seller_recommends_primary: andIn(temp, this.sellerrecommendsprimary).cids.length,
      seller_recommends_alternate: andIn(temp, this.sellerrecommendsalternate).cids.length,
      seller_recommends_self_cross: andIn(temp, orIn(this.sellerrecommendsselfcross, this.incumbentSelfCross)).cids.length,
      vizient_cross_attribute: andIn(temp, this.vizientcrossattribute).cids.length,
      vizient_cross_derived: andIn(temp, this.vizientcrossderived).cids.length,
      buyer_recommends: andIn(temp, this.buyerrecommendsprimary).cids.length
    };

  }
}
